define('SuiteDynamics.ShopByCategory.HorizontalCategories.View',
	[
		'Backbone',
		'horizontal_categories.tpl'
	],
	function (
		Backbone,
		horizontal_categories_tpl
	)
{
	'use strict';

	return Backbone.View.extend({
		template: horizontal_categories_tpl,

		events: {
			'click .scroll-left': 'scrollLeft',
			'click .scroll-right': 'scrollRight'
		},

		initialize: function (options) {
			var env = options.container.getComponent('Environment');
			this.categories = env.getConfig('shopByCategory.categories') || [];

			var layout = this.options.application.getLayout();
			var self = this;

			if (this.categories.length) {
				layout.once('afterAppendView', function () {
					self.bindScrollEvent();
					self.handleScroll();
				});
			}
		},

		bindScrollEvent: function () {
			var container = this.$('.shop-by-category-list');
			if (container.length) {
				container[0].addEventListener('scroll', this.handleScroll.bind(this));
			} else {
				console.warn('.shop-by-category-list not found');
			}
		},

		scrollLeft: function () {
			var container = this.$('.shop-by-category-list')[0];
			var itemWidth = this.getItemWidth();
			container.scrollLeft -= itemWidth;

			this.handleScroll();
		},

		scrollRight: function () {
			var container = this.$('.shop-by-category-list')[0];
			var itemWidth = this.getItemWidth();
			container.scrollLeft += itemWidth;

			this.handleScroll();
		},

		handleScroll: function () {
			var container = this.$('.shop-by-category-list')[0];
			var scrollLeftButton = this.$('.scroll-left');
			var scrollRightButton = this.$('.scroll-right');

			var scrollLeft = container.scrollLeft;
			var offsetWidth = container.offsetWidth;
			var scrollWidth = container.scrollWidth;

			var isAtStart = scrollLeft <= 1;
			var isAtEnd = scrollLeft + offsetWidth >= scrollWidth - 1;
			isAtEnd = isAtEnd || Math.abs((scrollLeft + offsetWidth) - scrollWidth) < 1;

			if (isAtStart) {
				scrollLeftButton.addClass('hidden');
			} else {
				scrollLeftButton.removeClass('hidden');
			}

			if (isAtEnd) {
				scrollRightButton.addClass('hidden');
			} else {
				scrollRightButton.removeClass('hidden');
			}
		},

		getItemWidth: function () {
			var firstItem = this.$('.shop-by-category-item:first');
			return firstItem.length ? firstItem.outerWidth(true) + 30 : 0;
		},

		getContext: function () {
			return {
				showSlider: this.categories.length > 0,
				categories: this.categories
			};
		}
	});
});
